import React, { useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';

import { AiOutlineMail } from 'react-icons/ai';

import profileImage from '../../assets/images/profile/profile-2026.png';
import logo from '../../assets/images/bg/arthur-iturres-2026-logo.png';
import '../../styles/pages/AboutPage.scss';

import ExpertiseLinks from '../UI/ExpertiseLinks.tsx';

import setPageTitle from '../../utils/setPageTitle.ts';

function AboutPage(): React.ReactElement {
  const $aboutPage = useRef<HTMLElement>(null);

  setPageTitle('About Arthur 🙋‍♂️');

  useEffect(() => {
    if ($aboutPage.current) {
      // * overrides the {display: none} on 'aboutPage.scss'.
      // * This is to prevent the aboutPage from showing before animation is applied.
      $aboutPage.current.style.display = 'flex';
      $aboutPage.current.classList.add('blend-in-out');
    }
  });

  return (
    <main ref={$aboutPage} className="aboutPage container">
      <div className="aboutPage__about">
        <h2 className="aboutPage__about-title">
          i&apos;m arthur!
          <span className="emoji">&#128075;</span>
        </h2>

        {/* <p className="status">
          <div className="status-indicator" />
          Currently working as TTL & Frontend Engineer at&nbsp;
          <a
            href="https://hellonetnet.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-hue-rotate"
          >
            Net Net
          </a>
        </p>

        <p className="status">
          <div className="status-indicator" />
          Currently working as Frontend Engineer at&nbsp;
          <a
            href="https://newm.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-hue-rotate"
          >
            NEWM
          </a>
        </p> */}

        <p className="aboutPage__about-p">
          I&apos;m a Front-End Engineer with full-stack experience, focused on
          designing and delivering reliable, user-centered web interfaces,
          with strong attention to architecture, performance, and long-term maintainability.

          <br />

          I work effectively in collaborative, cross-functional environments and have
          partnered with distributed teams to deliver reliable, user-facing products.
          My experience spans modern technologies including React, Next.js, TypeScript,
          JavaScript, Angular, Redux, CSS/SCSS,Rails, and Django, allowing me to contribute across
          the full web stack when needed.

          <br />

          With a background shaped by international collaboration, I bring adaptability,
          clear communication, and a strong commitment to product quality and team
          success.

          <br />

          <span className="inner-p">
            I enjoy working with teams that value thoughtful engineering, strong user
            experience, and steady delivery of high-quality products.
          </span>
        </p>

        <ExpertiseLinks />

        <Link
          to="/homepage/contact"
          className="aboutPage__cta"
          title="This link will take you to the contact page."
        >
          <AiOutlineMail size={20} className="mail-icon text-hue-rotate" />
          &nbsp;Let&apos;s collaborate and drive success together. Reach out to
          discuss how we can achieve your goals. ( link )
        </Link>
      </div>
      <div className="aboutPage__images">
        <img
          src={logo}
          alt="an abstract dotted figure"
          className="image-layer figure"
        />
        <img
          src={profileImage}
          alt="my profile"
          className="image-layer profile"
        />
      </div>
    </main>
  );
}

export default AboutPage;
